import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslator } from 'translation/useTranslator';
import { OrderTypeCustomField } from '../../../../@types/orderTypes';

type OrderTypeCustomFieldsTableProps = {
  customFields: OrderTypeCustomField[];
};

const OrderTypeCustomFieldsTable = ({ customFields }: OrderTypeCustomFieldsTableProps) => {
  const translator = useTranslator();

  if (customFields.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translator.noCustomFieldsDefinedForThisOrderType()}
      </Typography>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>{translator.key()}</TableCell>
          <TableCell>{translator.label()}</TableCell>
          <TableCell>{translator.dataType()}</TableCell>
          <TableCell>{translator.required()}</TableCell>
          <TableCell>{translator.defaultValue()}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customFields.map((customField) => (
          <TableRow key={customField.id}>
            <TableCell sx={{ fontFamily: 'monospace' }}>{customField.key}</TableCell>
            <TableCell>{customField.label || '—'}</TableCell>
            <TableCell>
              {customField.dataType}
              {customField.enumValues.length > 0 && ` (${customField.enumValues.join(', ')})`}
            </TableCell>
            <TableCell>{customField.isRequired ? translator.yes() : translator.no()}</TableCell>
            <TableCell>{customField.defaultValue ?? '—'}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default OrderTypeCustomFieldsTable;
